<ng-container *ngIf="path(); else onlyDisplay">
  <a *ngIf="openNewWindow; else inSite" target="_blank"
     [href]="path()"
     (click)="onLinkClick($event)">
    <ng-container *ngIf="content"
                  [ngTemplateOutlet]="content"/>
  </a>
  <ng-template #inSite>
    <a [routerLink]="path()"
       [queryParams]="queryParam() ?? null"
       (click)="beforeNavigation($event)">
      <ng-container *ngIf="content"
                    [ngTemplateOutlet]="content"/>
    </a>
  </ng-template>
</ng-container>
<ng-template #onlyDisplay>
  <ng-container *ngIf="content"
                [ngTemplateOutlet]="content"/>
</ng-template>
